import React, { FC, useEffect, useRef, useState } from 'react';
import { Container, BanksLogo } from '../../../landing.common';
import { Title } from './components/title';
import { TopForm } from './components/top.form';
import { HowToSelect } from './components/how.to.select';
import { Benefits } from './components/benefits';
import { MainForm } from '../main.form';
import styles from './content.module.scss';

type Props = {
    onFormPassed: () => void;
};

export const LandingContent: FC<Props> = ({ onFormPassed }) => {
    const mainFormAnchorRef = useRef<HTMLDivElement>(null);
    const [isMainFormVisible, setIsMainFormVisible] = useState(false);

    const setMainFormVisibility = (value: boolean) => {
        if (isMainFormVisible !== value) {
            updateMainFormVisibility(value);
        }
    };

    const updateMainFormVisibility = (value: boolean) => setIsMainFormVisible(value);

    const scrollHandler = () => {
        const mainForm = mainFormAnchorRef.current;
        if (mainForm) {
            const { y: positionY } = mainForm.getBoundingClientRect();
            if (positionY > 10) {
                setMainFormVisibility(false);
            } else {
                setMainFormVisibility(true);
            }
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', scrollHandler);
        return () => {
            window.removeEventListener('scroll', scrollHandler);
        };
    }, [isMainFormVisible]);

    return (
        <>
            <Container>
                <Title />
                <TopForm isMainFormVisible={isMainFormVisible} />
            </Container>
            <BanksLogo className={styles['banks-logos']} />
            <Container>
                <HowToSelect />
                <Benefits />
                <div ref={mainFormAnchorRef}>
                    <MainForm onFormPassed={onFormPassed} />
                </div>
            </Container>
        </>
    );
};
